// extracted by mini-css-extract-plugin
export default {"page":"FlaggedItems_page__0I6Sz","header":"FlaggedItems_header__7Grl1"};